<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";
import VRadioTextWithBlockLabel from "../../Form/Survey/VRadioTextWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import intus from "@/Plugins/intus";
import { isRequired, isInteger } from "intus/rules";

import { scrollOnError } from "@/Helpers/validation";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    is_this_your_first_time_in_sabah: answers?.is_this_your_first_time_in_sabah,
    what_is_your_main_purpose_visiting_sabah:
        answers?.what_is_your_main_purpose_visiting_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(
        form.data(),
        {
            is_this_your_first_time_in_sabah: [isRequired()],
            what_is_your_main_purpose_visiting_sabah: [isRequired()],
        },
        {
            ...intus.messages,
            is_this_your_first_time_in_sabah:
                surveyFields["is_this_your_first_time_in_sabah"]?.name,
            what_is_your_main_purpose_visiting_sabah:
                surveyFields["what_is_your_main_purpose_visiting_sabah"]?.name,
        }
    );

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VRadioWithBlockLabel
                        elId="is_this_your_first_time_in_sabah"
                        v-model:value="form.is_this_your_first_time_in_sabah"
                        :label="
                            surveyFields['is_this_your_first_time_in_sabah']
                                ?.name
                        "
                        :options="
                            surveyFields[
                                'is_this_your_first_time_in_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="form.errors?.is_this_your_first_time_in_sabah"
                    />
                </div>
                <div class="mb-3">
                    <VRadioTextWithBlockLabel
                        elId="what_is_your_main_purpose_visiting_sabah"
                        v-model:value="
                            form.what_is_your_main_purpose_visiting_sabah
                        "
                        :label="
                            surveyFields[
                                'what_is_your_main_purpose_visiting_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'what_is_your_main_purpose_visiting_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'what_is_your_main_purpose_visiting_sabah'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'what_is_your_main_purpose_visiting_sabah'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.what_is_your_main_purpose_visiting_sabah
                        "
                    />
                </div>
            </div>
        </div>
        <VDevider />

        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                {{ $t("public.page.survey.button.next") }}
            </VButtonSubmit>
        </div>
    </div>
</template>
